import { FC } from 'react';
import styled from '@emotion/styled';
import { display } from 'styled-system';

export const PlusDivider = styled(({ className }) => <span className={className}>{' + '}</span>)`
  ${display};
`;

export const NewLineDivider = styled(({ className }) => <br className={className} />)`
  ${display};
`;

export const Divider: FC = () => (
  <>
    <PlusDivider display={['none', 'inline']} />
    <NewLineDivider display={['block', 'none']} />
  </>
);

export default Divider;
